import * as api from "../../api/index";
import {
  CREATEORDER,
  FETCHORDER,
  FETCHORDERS,
  PLACESTRIPEORDER,
} from "../constants/orderContants";
import { message } from "antd";

export const createOrder = (formData, history) => async (dispatch) => {
  try {
    const { data } = await api.createOrder(formData);
    dispatch({ type: CREATEORDER, data });
    if (data) {
      history("/confirmation");
      message.success("Order placed successfully");
      localStorage.removeItem("cart");
      localStorage.setItem("orderId", JSON.stringify(data?._id));
      window.location.reload(true);
    }
  } catch (error) {
    if (error) {
      history("/cart");
      console.log(error?.response?.data);
      message.error(error?.response?.data);
    }
  }
};

export const getCurrentUserOrder = (userId) => async (dispatch) => {
  try {
    const { data } = await api.getOrders(userId);
    dispatch({ type: FETCHORDERS, payload: data });
  } catch (error) {
    console.log(error);
  }
};

export const postOrderStripe =
  (amount, id, description, currency) => async (dispatch) => {
    try {
      const { data } = await api.postOrderStripe(
        amount,
        id,
        description,
        currency
      );
      dispatch({ type: PLACESTRIPEORDER, payload: data });
      if (data) {
        // window.location.href = data.url;
        localStorage.removeItem("cart");
      }
    } catch (error) {
      console.log(error);
    }
  };

export const getOrder = (orderId) => async (dispatch) => {
  try {
    const { data } = await api.getOrder(orderId);
    dispatch({ type: FETCHORDER, payload: data });
  } catch (error) {
    console.log(error);
  }
};

// export const updateOrder =
//   (id, formData, history, setLoadingButton) => async (dispatch) => {
//     try {
//       const { data } = await api.updateOrder(id, formData);
//       dispatch({ type: UPDATEORDER, payload: data });
//       if (data?._id) {
//         setLoadingButton(false);
//         history("/orders");
//         message.success("Order updated successfully");
//       }
//     } catch (error) {
//       if (error) {
//         setLoadingButton(false);
//         console.log(error);
//         message.error(error.response.data);
//       }
//     }
//   };
